// @ts-check
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Checkbox, Link } from '../../../ui'
import { useStore } from '../../../StateProvider'
import { getUserValue } from '../utils'

const ExternalPrivacyPolicy = ({ name }) => {
  const { t } = useTranslation()
  const [{ whitelabel: { privacyPolicyURL }, user, form: { accId } }, dispatch] = useStore()
  const [isChecked, setIsChecked] = useState(false)
  const userValue = getUserValue(accId, user, name)

  useEffect(() => {
    if (!privacyPolicyURL || !privacyPolicyURL.length) {
      dispatch({ type: 'removeFieldValue', name })
      dispatch({ type: 'removeValidationFld', name })
    }
  }, [privacyPolicyURL])

  useEffect(() => {
    if (privacyPolicyURL?.length && userValue) {
      dispatch({ type: 'setExtFieldValue', name, value: userValue })
      dispatch({ type: 'setValidationFld', name, value: userValue })
      setIsChecked(userValue)
    }
  }, [userValue, privacyPolicyURL])

  const onCheckboxChange = () => {
    setIsChecked(value => !value)
    dispatch({ type: 'setExtFieldValue', name, value: !isChecked })
    dispatch({ type: 'setValidationFld', name, value: !isChecked })
  }

  return privacyPolicyURL && privacyPolicyURL.length ? (
    <Checkbox
      name={name}
      onChange={onCheckboxChange}
      isChecked={isChecked}
    >
      <>
        {t('createAccountForm.agreeTxt')}
        <Link href={privacyPolicyURL} target='_blank'>
          {t('createAccountForm.policyText')}
        </Link>
      </>
    </Checkbox>) : null
}

const getExternalPrivacyPolicyField = field => {
  const { name } = field
  return (
    <ExternalPrivacyPolicy
      name={name}
      key={name}
    />
  )
}

export { ExternalPrivacyPolicy, getExternalPrivacyPolicyField }
